import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { injectIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Text from '../../components/inputs/Text';

const styles = theme => ({
  body: {
    borderLeft: `3px solid ${theme.palette.primary[500]}`,
  },
});

@withStyles(styles)
@reduxForm({})
@injectIntl
export class UserDialog extends Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handleConfirm = name => {
    this.props.onCreate(name);
  };

  render() {
    const {
      title,
      handleSubmit,
      pristine,
      submitting,
      classes,
      children,
      intl: { messages: m },
      disabled,
    } = this.props;
    const { open } = this.state;

    return (
      <div>
        {React.cloneElement(children, { onClick: this.handleOpen, disabled })}
        <Dialog
          open={open}
          aria-labelledby="simple-dialog-title"
          classes={{ paper: classes.body }}
        >
          <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
          <form
            onSubmit={handleSubmit(this.handleConfirm)}
            autoComplete="something-unsupported"
          >
            <DialogContent>
              <div>
                <Field
                  name="email"
                  type="email"
                  component={Text}
                  label={m.field_email}
                  autoFocus
                  required
                />
                <Field
                  name="username"
                  component={Text}
                  label={m.field_username}
                  required
                />
                <Field
                  name="firstname"
                  component={Text}
                  label={m.field_firstname}
                  required
                />
                <Field
                  name="lastname"
                  component={Text}
                  label={m.field_lastname}
                  required
                />
                <Field
                  name="plainPassword"
                  component={Text}
                  type="password"
                  label={m.field_password}
                  style={{ marginTop: 16 }}
                  required
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={this.handleClose} disabled={submitting}>
                {m.button_cancel}
              </Button>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={pristine || submitting}
              >
                {m.button_create}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  }
}
